import gql from 'graphql-tag';

export default gql`
    mutation SaveJobPlannedStages($input: SaveJobPlannedStagesInput!) {
        saveJobPlannedStages(input: $input) {
            errors
        }
    }
`;
